import styles from "./styles.module.scss";
import React from "react";
import WordLevelRenderer from "./WordLevelRenderer";

export default function SegmentGroup({
  segments,
  onSegmentClick,
  currentSegment,
  onEditClick,
  selectedRange,
  onSegmentDoubleClick,
  stopEditing,
  words,
  currentPlayingWord,
  onWordClick,
  enableWordLevel = true,
  editingSpeaker,
  editingSpeakerText,
  onSpeakerEdit,
  onSpeakerTextChange,
  onSpeakerSave,
  onSpeakerCancel,
  onSpeakerKeyPress,
}) {
  const isSegmentSelected = (segment) => {
    if (selectedRange.start && selectedRange.end) {
      const startIndex = segments.findIndex(
        (s) => s.id === selectedRange.start.id
      );
      const endIndex = segments.findIndex((s) => s.id === selectedRange.end.id);
      const currentIndex = segments.findIndex((s) => s.id === segment.id);
      return (
        currentIndex >= Math.min(startIndex, endIndex) &&
        currentIndex <= Math.max(startIndex, endIndex)
      );
    }
    return false;
  };

  const shouldShowEditIcon = (segment) => {
    if (selectedRange.start && !selectedRange.end) {
      return segment.id === selectedRange.start.id;
    } else if (selectedRange.start && selectedRange.end) {
      return segment.id === selectedRange.end.id;
    }
    return false;
  };

  function renderWithLineBreaks(text) {
    return text.split("\n").map((str, index, array) =>
      index === array.length - 1 ? (
        str
      ) : (
        <React.Fragment key={index}>
          {str}
          <br />
        </React.Fragment>
      )
    );
  }

  const currentSpeaker = segments[0].speaker;
  const isEditingThisSpeaker = editingSpeaker === currentSpeaker;

  return (
    <div className={styles.segmentGroup}>
      <h4>
        {isEditingThisSpeaker ? (
          <input
            type="text"
            value={editingSpeakerText}
            onChange={(e) => onSpeakerTextChange && onSpeakerTextChange(e.target.value)}
            onBlur={onSpeakerSave}
            onKeyDown={onSpeakerKeyPress}
            autoFocus
            style={{
              border: '2px solid #007bff',
              borderRadius: '4px',
              padding: '4px 8px',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              background: 'white',
              minWidth: '100px'
            }}
          />
        ) : (
          <span
            onClick={() => onSpeakerEdit && onSpeakerEdit(currentSpeaker)}
            style={{
              cursor: 'pointer',
              padding: '2px 4px',
              borderRadius: '4px',
              border: '1px solid transparent',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f0f0f0';
              e.target.style.borderColor = '#ddd';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = 'transparent';
            }}
            title="Click to edit speaker name"
          >
            {currentSpeaker}:
          </span>
        )}
      </h4>
      <div>
        {segments.map((segment, index) => (
          <span
            id={`segment-${segment.id}`}
            key={index + "-id"}
            className={`${styles.chunkWrapper} ${
              currentSegment?.id === segment.id || isSegmentSelected(segment)
                ? styles.selected
                : ""
            }`}
          >
            <span
              className={`${styles.chunk} ${
                currentSegment?.id === segment.id || isSegmentSelected(segment)
                  ? styles.selected
                  : ""
              }`}
              onClick={
                stopEditing
                  ? () => {}
                  : (e) => {
                      // Don't preventDefault - allow normal browser behavior (video controls)
                      // Only handle our custom segment selection logic
                      onSegmentClick(segment, e);
                    }
              }
              onDoubleClick={(e) => {
                e.preventDefault();
                onSegmentDoubleClick(segment.start);
              }}
            >
              {enableWordLevel && words && words.length > 0 ? (
                <WordLevelRenderer
                  segment={segment}
                  words={words}
                  currentPlayingWord={currentPlayingWord}
                  onWordClick={onWordClick}
                  isSegmentSelected={isSegmentSelected(segment)}
                />
              ) : (
                renderWithLineBreaks(segment.text)
              )}
            </span>
            {shouldShowEditIcon(segment) && !stopEditing && (
              <img
                src={"/icons/blue-edit.svg"}
                alt="edit"
                className={styles.image}
                onClick={(e) => {
                  e.preventDefault();
                  onEditClick(segment);
                }}
              />
            )}
          </span>
        ))}
      </div>
    </div>
  );
}
